import React from 'react'
import PropTypes from 'prop-types'

import styles from './GameIdentity.scss'

const GlobalIdentity = ({ title }) =>{
    return (
        <div className={ styles.container }>
            <div className={ styles.content }>
                <div className={ styles.left }>

                    <div className={ styles.identity }>
                      

                        <div className={ styles.title }>
                            { title }
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}

GlobalIdentity.propTypes = {
    sponsorImageUrl: PropTypes.string,
    phase : PropTypes.object
}

export default GlobalIdentity;